import React, { useState } from "react";
import axios from "axios";
import "../styles/create-user.css";

const CreateUser = () => {
    const [formData, setFormData] = useState({
        username: "",
        password: "",
        name: "",
        role: "training-user",
    });
    const [message, setMessage] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(""); // clear previous messages

        try {
            const token = localStorage.getItem("jwt"); // retrieve jwt
            const response = await axios.post(
                "https://asldemologinauth-a8b2fpbnhrgygsaj.canadacentral-01.azurewebsites.net/auth/register",
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.status === 201) {
                setMessage(`User ${formData.username} created successfully!`);
            } else {
                setMessage("Failed to create user.");
            }
        } catch (err) {
            if (err.response?.status === 500) {
                setMessage("Failed to create user:\nA user with this username already exists.");
            } else {
                setMessage("Failed to create user:\n" + (err.response?.data?.error || "Server error."));
            }
            console.error(err);
        }
    };

    return (
        <div className="create-user-container">
            <form onSubmit={handleSubmit} autoComplete="off">
                <label>
                    Username:
                    <input
                        type="text"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        required
                        autoComplete="off"
                    />
                </label>
                <label>
                    Password:
                    <input
                        type="password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        autoComplete="new-password"
                    />
                </label>
                <label>
                    Name:
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                    />
                </label>
                <label>
                    Role:
                    <select name="role" value={formData.role} onChange={handleChange} required>
                        <option value="training-user">Training User</option>
                        <option value="demo-user">Demo User</option>
                        <option value="multi-user">Multi User</option>
                        <option value="admin">Admin</option>
                    </select>
                </label>
                <button type="submit">Create Account</button>
            </form>
            {message && (
                <p className={message.startsWith("Failed to create user") ? "error-message" : "success-message"}>
                    {message}
                </p>
            )}
        </div>
    );
};

export default CreateUser;